import React, { FC, memo, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  createTheme,
  ThemeProvider as BaseThemeProvider,
  getThemeByName,
  IThemeConstants,
  ThemeName,
} from "@evergis/ui";

import { getThemeName } from "../../ducks/theme/selectors";
import { getAppConfig } from "../../ducks/appConfig";
import { mergeObjects } from "../../utils/mergeObjects";

export const ThemeProvider: FC<{ themeName?: ThemeName }> = memo(({ children, themeName: themeNameProp }) => {
  const { settings } = useSelector(getAppConfig);
  const themeName = useSelector(getThemeName);

  const themeWithConfig = useMemo(() => {
    const currentThemeName = themeNameProp || themeName || settings?.theme?.name;
    const theme = getThemeByName(currentThemeName);
    let themeConstants = settings?.theme
      ? (mergeObjects(theme as unknown as Record<string, unknown>, settings.theme) as unknown as IThemeConstants)
      : theme;

    if (currentThemeName === ThemeName.Dark && settings?.theme?.paletteDark) {
      themeConstants = { ...themeConstants, palette: { ...themeConstants.palette, ...settings.theme.paletteDark } };
    }

    return createTheme(themeConstants);
  }, [settings?.theme, themeName, themeNameProp]);

  return <BaseThemeProvider theme={themeWithConfig}>{children}</BaseThemeProvider>;
});
